import { FormHelperText } from '@mui/material'
import React from 'react'

export default function ValidationErrorText({error}) {
 if(!error) return
  return (
   <FormHelperText error>{error}</FormHelperText>
  )
}
